import { cfApiClient } from '@/api/cf-worker-client';
import type { Configuration, ApiResponse, ConfigListResponse } from '@/types';

export const configurationsService = {
  getConfigurations: async (): Promise<Configuration[]> => {
    const response = await cfApiClient.get<ApiResponse<ConfigListResponse>>('/configurations');
    return response.data.configs;
  },

  updateConfiguration: async (key: string, value: string, description?: string): Promise<Configuration> => {
    const body: { value: string; description?: string } = { value };
    if (description !== undefined) {
      body.description = description;
    }
    const response = await cfApiClient.put<ApiResponse<Configuration>>(`/configurations/${encodeURIComponent(key)}`, body);
    return response.data;
  },
};
